export default {
  duration: 300,
  timingFunction: 'cubic-bezier(.4, 0, .2, 1)',
};
